import { render, staticRenderFns } from "./ReplyFakeInput.vue?vue&type=template&id=28c40666"
import script from "./ReplyFakeInput.vue?vue&type=script&lang=js"
export * from "./ReplyFakeInput.vue?vue&type=script&lang=js"
import style0 from "./ReplyFakeInput.vue?vue&type=style&index=0&id=28c40666&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports